var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderVersionHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3257 2C12.5325 2.52049 11.8556 3.20245 11.3413 4H7.81787V6H10.4702C10.3357 6.53239 10.2642 7.08987 10.2642 7.66406C10.2642 7.77672 10.2675 7.88869 10.2729 8H5.81787V6H3.81787V20H17.8179V14.3887C18.5236 14.3074 19.1953 14.1171 19.8179 13.8359V21.0068C19.8177 21.5553 19.3722 22 18.8237 22H2.81104C2.26247 22 1.81702 21.5552 1.81689 21.0068V4.99316C1.81702 4.44463 2.26266 4 2.81104 4H5.81787V2H13.3257Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5511 13.1472C13.5586 13.1472 11.1328 10.7214 11.1328 7.72888C11.1328 4.73634 13.5586 2.31055 16.5511 2.31055C19.5437 2.31055 21.9695 4.73634 21.9695 7.72888C21.9695 10.7214 19.5437 13.1472 16.5511 13.1472ZM16.5511 12.0635C17.7008 12.0635 18.8033 11.6069 19.6162 10.794C20.4291 9.98105 20.8858 8.87851 20.8858 7.72888C20.8858 6.57926 20.4291 5.47672 19.6162 4.66381C18.8033 3.8509 17.7008 3.39421 16.5511 3.39421C15.4015 3.39421 14.299 3.8509 13.4861 4.66381C12.6732 5.47672 12.2165 6.57926 12.2165 7.72888C12.2165 8.87851 12.6732 9.98105 13.4861 10.794C14.299 11.6069 15.4015 12.0635 16.5511 12.0635ZM17.093 7.72888H19.2603V8.81255H16.0093V5.01971H17.093V7.72888Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderVersionHistory);
export default __webpack_public_path__ + "static/media/order-version-history.b14c3464bfe82cce320c795b529aeef0.svg";
export { ForwardRef as ReactComponent };